__turbopack_context__.v({
  "arrows": "sixY5W_arrows",
  "container": "sixY5W_container",
  "content": "sixY5W_content",
  "credit": "sixY5W_credit",
  "hero-reveal": "sixY5W_hero-reveal",
  "image": "sixY5W_image",
  "portrait": "sixY5W_portrait",
  "quote": "sixY5W_quote",
  "quote-container": "sixY5W_quote-container",
  "text": "sixY5W_text",
  "text-container": "sixY5W_text-container",
  "title": "sixY5W_title",
});
